'use strict';

export const ENV = {
  BASE_URL: process.env.VUE_APP_BASE_URL,
  SECURE_LS_SECRET: process.env.VUE_APP_SECURE_LS_SECRET,
  IS_DEVELOPMENT: process.env.NODE_ENV === 'development',
  IS_PRODUCTION: process.env.NODE_ENV === 'production',
  BACKEND_BASE_URL: process.env.VUE_APP_BACKEND_BASE_URL
};

if (ENV.IS_PRODUCTION && !ENV.SECURE_LS_SECRET) {
  throw new Error("CRITICAL: VUE_APP_SECURE_LS_SECRET is not defined in production environment!");
}

export default ENV;